module.exports = __webpack_public_path__ + "img/love.c24b23c9.svg";